import {
  getMemberByToken,
  getUserMenu
}
from "@/api/user";
export default {
  namespaced: true,
  state: {
    userInfo: {},
    userMenu: []
  },
  mutations: {
    set_userInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    set_userMenu: (state, userMenu) => {
      state.userMenu = userMenu;
    }
  },
  actions: {

    async getMemberByToken({
      commit
    }) {
      const response = await getMemberByToken();
      commit("set_userInfo", response.data);
      return response.data;
    },

    // 获取用户信息
    async getUserInfo({ commit }) {
      const { data } = await getMemberByToken();
      commit('set_userInfo', data);
      return data;
    },
    async getUserMenu({ commit }, param) {
      const { data } = await getUserMenu(param);
      sessionStorage.setItem('menu', JSON.stringify(data));
      commit('set_userMenu', data);
      return data;
    }
  }
}
